import { Button } from "@joor/design-system";
import Mixpanel from "mixpanel-browser";
import styled from "styled-components/macro";

import { useAssortmentId } from "components/Routes";
import getJoorReactAssortmentUrl from "getJoorReactAssortmentUrl";

const LinkContainer = styled.span`
  padding: 4px 8px;
`;

/**
 * Display the "Back to Classic" button (a viewer dependent component)
 */
const ToClassicButton = () => {
  const assortmentId = useAssortmentId();
  return (
    <LinkContainer>
      <Button
        data-testid="classic-btn"
        onClick={() => {
          try {
            Mixpanel.track("Click Switch to Classic");
          } catch (e) {}
          window.location.assign(getJoorReactAssortmentUrl(assortmentId));
        }}
      >
        Switch To Classic Experience
      </Button>
    </LinkContainer>
  );
};

export default ToClassicButton;
